import { z } from 'zod'
import {
  BaseFormAnswerSchema,
  BaseFormQuestionSchema,
} from '@omnea-app/packages/universal/formBuilder/BaseFormQuestionAndAnswerSchemas'

// Used in commit supplier data forms to configure how a supplier's product appears in the
// product catalogue.

export const ProductCatalogueAccessTypeSchema = z.enum(['EMAIL', 'DIRECT', 'TICKET', 'WORKFLOW'])
export type ProductCatalogueAccessType = z.infer<typeof ProductCatalogueAccessTypeSchema>

const AccessApproverSchema = z.object({
  id: z.uuid(),
  type: z.enum(['USER', 'GROUP']),
  name: z.string(),
})

export const ProductCatalogueAccessConfigBaseSchema = z.object({
  accessWorkflowId: z.string().nullable(),
  accessInstructions: z.string().nullable(),
  externalEmail: z.string().nullable(),
})

export const ProductCatalogueAccessValueSchema = ProductCatalogueAccessConfigBaseSchema.extend({
  showInCatalogue: z.boolean(),
  categoryIds: z.array(z.uuid()).optional(),
  accessApprover: AccessApproverSchema.nullable(),
  accessUrl: z.string().nullable(),
  accessType: ProductCatalogueAccessTypeSchema.nullable(),
})
export type ProductCatalogueAccessValue = z.infer<typeof ProductCatalogueAccessValueSchema>

export const ProductCatalogueAccessFormQuestionSchema = BaseFormQuestionSchema.extend({
  type: z.literal('productCatalogueAccess'),
})
export type ProductCatalogueAccessFormQuestion = z.infer<typeof ProductCatalogueAccessFormQuestionSchema>

export const ProductCatalogueAccessFormAnswerSchema = BaseFormAnswerSchema.extend({
  type: z.literal('productCatalogueAccess'),
  value: ProductCatalogueAccessValueSchema.nullable(),
})
export type ProductCatalogueAccessFormAnswer = z.infer<typeof ProductCatalogueAccessFormAnswerSchema>
